// packages/web-ui/src/components/kb-browser/highlight-match.tsx
//
// Story W4-S5 (AC #2.3) — wrap matching substrings of `name` in
// `<mark>` tags for in-tree search highlight. Case-insensitive; multiple
// occurrences highlighted; empty query returns the input verbatim.

import type { ReactNode } from 'react';

/**
 * Returns a React fragment that highlights every case-insensitive occurrence
 * of `query` in `name` with a `<mark>` element. When `query` is empty the
 * function returns the original string (no fragment overhead).
 */
export function highlightMatch(name: string, query: string): ReactNode {
  if (query.length === 0) return name;
  const lowerName = name.toLowerCase();
  const lowerQuery = query.toLowerCase();
  const parts: ReactNode[] = [];
  let cursor = 0;
  let key = 0;
  while (cursor < name.length) {
    const idx = lowerName.indexOf(lowerQuery, cursor);
    if (idx === -1) {
      parts.push(name.slice(cursor));
      break;
    }
    if (idx > cursor) parts.push(name.slice(cursor, idx));
    parts.push(
      <mark
        key={`m-${String(key++)}`}
        data-testid="highlight"
        className="bg-[var(--accent-cream-active)] text-inherit"
      >
        {name.slice(idx, idx + query.length)}
      </mark>,
    );
    cursor = idx + query.length;
  }
  return <>{parts}</>;
}
